import { render, staticRenderFns } from "./ColumnNameAliasTable.vue?vue&type=template&id=5264988b"
import script from "./ColumnNameAliasTable.vue?vue&type=script&lang=js"
export * from "./ColumnNameAliasTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports